export default "__VITE_ASSET__Db4b1UKM__"